<template>
  <div class="box-padding">
    <div class="top-of-box-full">
      <b>
        {{ titreDeLaBoite }}
      </b>
    </div>
    <div class="small-blue-box">
      <div v-if="!solobox">
        <div class="liens-rapports" v-for="liens of listeDeLiens" :key="liens.titre">
          <BoiteLiens :titre="liens.titre" :liens="liens.liens" :solobox="solobox"/>
        </div>
      </div>
      <div class="liens-rapports" v-else>
        <BoiteLiens :liens="listeDeLiens" :solobox="solobox"/>
      </div>
    </div>
  </div>
</template>

<script>

import BoiteLiens from "@/components/rapports/dashboard/BoiteLiens.vue";

export default {
  name: "BoiteBleu",
  components: {BoiteLiens},
  props: {
    titreDeLaBoite: String,
    solobox: Boolean,
    listeDeLiens: Array,
  }
}
</script>
